export default {
    headerHeight: 100,
    sidebarWidth: 205
};
